import { AppStore } from "../stores/AppStore.js";

export const updateEmployee = (userId, updatedData) => {
    AppStore.update(s => {
        const userIndex = s.employees.findIndex(user => user.id === userId);
        if (userIndex !== -1) {
            s.employees[userIndex] = { ...s.employees[userIndex], ...updatedData };
        }
    });
};

export const updateLocalArrayObjects = (localItem, id, fieldsChanged) => {

    AppStore.update((s) => {
        if (!s[localItem]) return;
        const index = s[localItem].findIndex(item => item.id === id);

        if (index !== -1) {
            s[localItem][index] = { ...s[localItem][index], ...fieldsChanged };
        }
    });
}

export const updateLocalArrayObjects1 = (localItem, id, fieldsChanged) => {
    AppStore.update((s) => {
        if (!s[localItem]) return;
        s[localItem] = s[localItem].map(item => {
            const updatedFields = { ...fieldsChanged };
            Object.keys(updatedFields).forEach(key => {
                if (updatedFields[key] && updatedFields[key]._isAMomentObject) {
                    updatedFields[key] = updatedFields[key].toISOString();
                } else if (updatedFields[key] && key === 'checkinGoalData') {
                    updatedFields['check_in_goals'] = updatedFields['check_in_goals'].map((item, index) => {
                        const checkIn = updatedFields?.checkinGoalData.find(goal => goal.id === item.id)
                        return checkIn;
                    })
                }
            });
            return item.id === parseInt(id) ? { ...item, ...updatedFields } : item;
        }
        );
    });
}

export const updateCheckInGoalsLocalArrayObjects = (localItem, checkInId, fieldsChanged) => {

    AppStore.update((s) => {
        if (!s[localItem]) return;
        s[localItem] = fieldsChanged.map(checkIn => {
            if (checkIn.id === parseInt(checkInId)) {
                checkIn.check_in_goals = checkIn.checkinGoalData.map(goal => {

                    console.log('goal', goal);

                    const updatedGoal = fieldsChanged.find(field => field.id === parseInt(goal.id));
                    return updatedGoal ? { ...goal, ...updatedGoal } : goal;
                });
            }
            return checkIn;
        });
    });
};

export const createLocalArrayObject = (localItem, newItem) => {
    AppStore.update((s) => {
        if (!s[localItem]) {
            s[localItem] = [];
        }
        s[localItem].push(newItem);
    });
};

export const deleteLocalArrayObject = (localItem, id) => {
    AppStore.update((s) => {
        if (!s[localItem]) return;
        s[localItem] = s[localItem].filter(item => item.id !== id);
    });
};